import React from 'react'
import Navigation from '@App/navigation'
import { getDSPLink } from '@App/helpers/get-dsp-link'
import { getFormattedDspName } from '@App/helpers/get-dsp-name'
import { Recording } from '@Entities/matching/recording-group-details'

interface MatchDetailsRowProps {
    recording: Recording
}

const MatchDetailsRow = (props: MatchDetailsRowProps) => {
    const { recording } = props
    const link = getDSPLink(recording.dspMNumber, recording.dspReleaseId, recording.senderResourceId)
    const recordingId = `${recording.dspMNumber}-${recording.senderResourceId}`
    return (
        <tr>
            <td>{getFormattedDspName(recording.dsp)?.toUpperCase()}</td>
            <td>{recording.recordingTitle}</td>
            <td>{recording.recordingDisplayArtistName}</td>
            <td>{recording.label}</td>
            <td>
                {link ? (
                    <a target="_blank" className="blue-link" href={link} rel="noreferrer">
                        Listen
                    </a>
                ) : (
                    <p className="not-available">Listen</p>
                )}
            </td>
            <td>
                <a target="_blank" href={Navigation.recordingDetails.root(recordingId)} rel="noreferrer">
                    View
                </a>
            </td>
        </tr>
    )
}

export default MatchDetailsRow
